import { USER_APP_ENTITLEMENTS_API } from 'constants/AppConstants';
import { getTokenFromUrl } from 'utils/auth.utils';

/**
 * Service to fetch user entitled apps
 */
const getUserEntitlements = async () => {
  try {
    const token = getTokenFromUrl();
    const response = await fetch(USER_APP_ENTITLEMENTS_API, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });

    const json = await response.json();

    if (response.status !== 200) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, error };
  }
};

export default getUserEntitlements;
